import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { SpecialOrderCustomer } from "../../types/special-order.type";
import { billtypeLabel, taxtypeLabel } from "./data";

/**
 * The customer's billing terms an order inherits — none of them is chosen on the order:
 * ขายสด/ขายเชื่อ decides IV vs IC, the taxtype how VAT is worked out, the discount comes off
 * the whole bill, and an e-Tax customer's bill joins the e-Tax queue once delivered.
 */
export default function CustomerTermsChips({
  customer,
  taxtype,
  discountPercent,
}: Readonly<{
  customer: Pick<SpecialOrderCustomer, "billtype" | "taxtype" | "etax_enabled" | "discount_percent">;
  /** The order's snapshot, when there is one; otherwise the customer's. */
  taxtype?: string | null;
  discountPercent?: number | null;
}>) {
  const resolvedTaxtype = taxtype !== undefined ? taxtype : customer.taxtype;
  const resolvedDiscount =
    discountPercent !== undefined ? discountPercent : customer.discount_percent;

  return (
    <Box display="flex" flexWrap="wrap" gap={1}>
      <Chip
        size="small"
        variant="outlined"
        color={customer.billtype === "cash" ? "success" : "primary"}
        label={billtypeLabel(customer.billtype)}
      />
      <Chip size="small" variant="outlined" label={taxtypeLabel(resolvedTaxtype)} />
      {resolvedDiscount != null && resolvedDiscount > 0 && (
        <Chip
          size="small"
          variant="outlined"
          color="warning"
          label={`ส่วนลด ${resolvedDiscount}%`}
        />
      )}
      <Chip
        size="small"
        variant={customer.etax_enabled ? "filled" : "outlined"}
        color={customer.etax_enabled ? "info" : "default"}
        label={customer.etax_enabled ? "e-Tax" : "e-Tax: ไม่เปิด"}
      />
    </Box>
  );
}
